import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/dev-site/dev-site/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import '../styles/main.css';
import HomeResourceCard from './home/home-resource.md';
import HomeMiniCards from './home/home-minicards.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const WrapperComponent = makeShortcode("WrapperComponent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



<Hero slots="image, heading, text, buttons" variant="fullwidth" background="rgb(15, 55, 95)" className="index-hero" mdxType="Hero" />
<p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "43.125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/1bde5b5c22354eeb704997730716596c/5530d/Dev-Hero-banner-2.webp 320w", "/static/1bde5b5c22354eeb704997730716596c/0c8fb/Dev-Hero-banner-2.webp 640w", "/static/1bde5b5c22354eeb704997730716596c/94b1e/Dev-Hero-banner-2.webp 1280w", "/static/1bde5b5c22354eeb704997730716596c/64296/Dev-Hero-banner-2.webp 1600w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/1bde5b5c22354eeb704997730716596c/dd4a7/Dev-Hero-banner-2.png 320w", "/static/1bde5b5c22354eeb704997730716596c/0f09e/Dev-Hero-banner-2.png 640w", "/static/1bde5b5c22354eeb704997730716596c/bbbf7/Dev-Hero-banner-2.png 1280w", "/static/1bde5b5c22354eeb704997730716596c/42cbc/Dev-Hero-banner-2.png 1600w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/static/1bde5b5c22354eeb704997730716596c/bbbf7/Dev-Hero-banner-2.png",
            "alt": "Dev Hero banner 2",
            "title": "Dev Hero banner 2",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
<h1 {...{
      "id": "the-most-memorable-digital-experiences-are-unleashed-by-developer-creativity"
    }}>{`The most memorable digital experiences are unleashed by developer creativity`}</h1>
<p>{`Adobe products and services empower developers`}</p>
<ul>
<li parentName="ul"><a parentName="li" {...{
          "href": "/apis"
        }}>{`Explore our APIs`}</a></li>
<li parentName="ul"><a parentName="li" {...{
          "href": "/ai-registry"
        }}>{`Explore AI Registry`}</a></li>
</ul>
<TitleBlock slots="heading" theme="lightest" className="Get-started-building" mdxType="TitleBlock" />
<h2 {...{
      "id": "featured-products"
    }}>{`Featured Products`}</h2>
<HomeMiniCards mdxType="HomeMiniCards" />
<TextBlock slots="buttons" isCentered theme="lightest" className='Use-cases-for-Adobe-Document-Services home-news-button index-developer-products' mdxType="TextBlock" />
<ul>
<li parentName="ul"><a parentName="li" {...{
          "href": "/apis"
        }}>{`View All Developer Products`}</a></li>
</ul>
<TitleBlock slots="heading" theme="lightest" className="Get-started-building" mdxType="TitleBlock" />
<h1 {...{
      "id": "get-started-building-with-adobe"
    }}>{`Get started building with Adobe`}</h1>
<TextBlock slots="image, text" width="33%" isCentered theme="lightest" className="text-style index-developer-products" mdxType="TextBlock" />
<p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "320px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.5%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/14b6039bff4b387b6a2afe734f64cd00/5530d/home-illustration1.webp 320w"],
            "sizes": "(max-width: 320px) 100vw, 320px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/14b6039bff4b387b6a2afe734f64cd00/dd4a7/home-illustration1.png 320w"],
            "sizes": "(max-width: 320px) 100vw, 320px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/static/14b6039bff4b387b6a2afe734f64cd00/dd4a7/home-illustration1.png",
            "alt": "home illustration1",
            "title": "home illustration1",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
<p><a parentName="p" {...{
        "href": "http://developer.adobe.com/console"
      }}>{`Launch the Adobe Developer Console:`}</a>{` The ultimate developer destination to access Adobe APIs & SDKs.`}</p>
<TextBlock slots="image, text" width="33%" isCentered theme="lightest" className="text-style index-exchange-adobe" mdxType="TextBlock" />
<p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "320px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.5%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/c372947a10899ea169a13023afb1e20f/5530d/home-illustration2.webp 320w"],
            "sizes": "(max-width: 320px) 100vw, 320px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/c372947a10899ea169a13023afb1e20f/dd4a7/home-illustration2.png 320w"],
            "sizes": "(max-width: 320px) 100vw, 320px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/static/c372947a10899ea169a13023afb1e20f/dd4a7/home-illustration2.png",
            "alt": "home illustration2",
            "title": "home illustration2",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
<p>{`See what Adobe Developers have created on the `}<a parentName="p" {...{
        "href": "http://exchange.adobe.com/"
      }}>{`Adobe Exchange Marketplace`}</a></p>
<TextBlock slots="image, text" width="33%" isCentered theme="lightest" className="text-style index-adobe-tech-blog" mdxType="TextBlock" />
<p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "320px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.5%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/b1f6c7283e6654e6edb0e73ed6e7592f/5530d/home-illustration3.webp 320w"],
            "sizes": "(max-width: 320px) 100vw, 320px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/b1f6c7283e6654e6edb0e73ed6e7592f/dd4a7/home-illustration3.png 320w"],
            "sizes": "(max-width: 320px) 100vw, 320px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/static/b1f6c7283e6654e6edb0e73ed6e7592f/dd4a7/home-illustration3.png",
            "alt": "home illustration3",
            "title": "home illustration3",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
<p>{`Never miss a story from the `}<a parentName="p" {...{
        "href": "http://blog.developer.adobe.com/"
      }}>{`Adobe Developers Blog`}</a></p>
<WrapperComponent slots="content" repeat="1" theme="lightest" className="Use-cases-for-Adobe-Document-Services" mdxType="WrapperComponent" />
<HomeResourceCard mdxType="HomeResourceCard" />
<TextBlock slots="buttons" isCentered theme="lightest" className='Use-cases-for-Adobe-Document-Services home-news-button index-learn-more' mdxType="TextBlock" />
<ul>
<li parentName="ul"><a parentName="li" {...{
          "href": "https://blog.developer.adobe.com/"
        }}>{`Learn More`}</a></li>
</ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      